import AddContactButton from './AddContactButton';

export default AddContactButton;


// WEBPACK FOOTER //
// ./src/components/AddContactButton/index.js